import React from 'react';
import withIcon from '../utilities/withIcon';

const IconImage = () => {
  return (
    <g>
      <path d="m15.1553 1.145h-14.3106a.75.75 0 0 0 -.75.75v12.21a.75.75 0 0 0 .75.75h14.3106a.75.75 0 0 0 .75-.75v-12.21a.75.75 0 0 0 -.75-.75zm-.75 1.5v6.9432l-2.1084-1.8982a.77.77 0 0 0 -.544-.1914.7531.7531 0 0 0 -.52.2515l-2.0288 2.2909-3.3135-3.314a.7517.7517 0 0 0 -1.0117-.0454l-3.2842 2.7452v-6.7818zm-12.8106 10.71v-1.972l3.7207-3.11 3.3916 3.392a.71.71 0 0 0 .5527.2192.7493.7493 0 0 0 .5391-.252l2.0567-2.3212 2.55 2.2961v1.7479z" />
      <path d="m8.99 7.9575a2.35 2.35 0 1 0 -2.35-2.3501 2.3523 2.3523 0 0 0 2.35 2.3501zm0-3.3a.95.95 0 1 1 -.95.95.95.95 0 0 1 .95-.9498z" />
    </g>
  );
};

export default withIcon(IconImage);
